import React from "react";
import { Search, X, Calendar as CalendarIcon } from "lucide-react";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Calendar } from "../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../components/ui/popover";

const DateField = ({ value, onChange, testid, placeholder }) => {
    const date = value ? parseISO(value) : undefined;
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button data-testid={testid} className="mt-1 flex h-10 w-full min-w-[150px] items-center gap-2 rounded-xl border border-input bg-background px-3 text-left text-sm">
                    <CalendarIcon className="h-4 w-4 text-muted-foreground" />
                    {date ? format(date, "dd/MM/yyyy", { locale: ptBR }) : <span className="text-muted-foreground">{placeholder}</span>}
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar mode="single" selected={date} onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")} locale={ptBR} initialFocus />
            </PopoverContent>
        </Popover>
    );
};

// Reusable filter bar: keyword + date period.
export const Filters = ({ q, start, end, onChange, placeholder = "Buscar por palavra-chave..." }) => {
    const clear = () => onChange({ q: "", start: "", end: "" });
    const active = q || start || end;
    return (
        <div className="flex flex-col gap-3 rounded-2xl border border-border bg-white p-4 md:flex-row md:items-end" data-testid="filters-bar">
            <div className="flex-1">
                <Label className="text-xs uppercase tracking-widest text-muted-foreground">Pesquisa</Label>
                <div className="relative mt-1">
                    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                    <Input
                        data-testid="filter-search-input"
                        value={q}
                        onChange={(e) => onChange({ q: e.target.value, start, end })}
                        placeholder={placeholder}
                        className="rounded-xl pl-9"
                    />
                </div>
            </div>
            <div>
                <Label className="text-xs uppercase tracking-widest text-muted-foreground">De</Label>
                <DateField value={start} onChange={(v) => onChange({ q, start: v, end })} testid="filter-start-date" placeholder="dd/mm/aaaa" />
            </div>
            <div>
                <Label className="text-xs uppercase tracking-widest text-muted-foreground">Até</Label>
                <DateField value={end} onChange={(v) => onChange({ q, start, end: v })} testid="filter-end-date" placeholder="dd/mm/aaaa" />
            </div>
            {active && (
                <button onClick={clear} data-testid="filter-clear-btn" className="inline-flex items-center gap-1 rounded-full border border-border px-4 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted">
                    <X className="h-4 w-4" /> Limpar
                </button>
            )}
        </div>
    );
};
